import classes from "./MainJS.module.css";
import Login from "./login/Login";
import Slideshow from "./slideShow/Slideshow";
import Dashboard from "./dashboard/Dashboard";
import {useEffect, useState, React} from "react";
import { path, assetsBaseUrl } from "../routes"
import axios from 'axios';
import SlideshowTotem from "./slideShow/SlideshowTotem";
import log from "../store/file-1719300636380.png"
import logoo from "../store/file-1718802261958.jpg"
import {CircularProgress} from "@mui/material";
import Loader from "./dashboard/Loader/Loader";
import Room from "./slideShow/Room/Room";
import Kiosk from "./slideShow/Kiosk/Kiosk";
import RadKiosk from "./slideShow/Kiosk/RadKiosk";
import RoomHI from "./slideShow/Room/Room_HolidayInn/RoomHI";
import Slide_bistro from "./slideShow/Slide_bistro";
import RoomVertical from "./slideShow/Room/Room_HolidayInn/RoomVertical";
import RoomDouble from "./slideShow/Room/Room_HolidayInn/RoomDouble";
import RoomDiplomat from "./Diplomat/ROOM/RoomDiplomat";
import KioskDiplomat from "./Diplomat/KIOSK/KioskDiplomat";
import Kiosk_viennaPlzen_redesign from "./slideShow/Kiosk/Kiosk_viennaPlzen_redesign";
import NewsFetchPost from "./NewsFetchPost";
import RadKiosk_FAIRMONT from "./slideShow/Kiosk/RadKiosk_FAIRMONT";
import Slideshow_FAIRMONT from "./slideShow/Slideshow_FAIRMONT";
import RoomFairmont from "./slideShow/Room/Room_FAIRMONT";
import FairmontLogo from "../store/Fairmont_logo.png"
import Kiosk_Harrachov from "./slideShow/Kiosk/Kiosk_Harrachov";
import Dashboard_admin from "./dashboard/Dashboard_admin";
import KIOSK_def from "./slideShow/Kiosk/KIOSK_def";
import FairmontKiosk from "./slideShow/Kiosk/FairmontKiosk";
import SkpKiosk from "./slideShow/Kiosk/SkpKiosk";

const FAIRMONT_GOLDEN_PRAGUE_ORG_ID = '7A67452A-F5D4-430D-B283-8A93B28B425C';


const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const DIPLOMAT_PRAGUE_ORG_ID = 'AC44260C-8496-4F02-9ECA-2B19F3C32726';
const SKP_HOPO_ORG_ID = '52F244B7-9391-403F-9E83-4C77626C781C';

const MainJS = () => {
    let day
    const [user, setUser] = useState()

    // --- Zrychlené určení "routu" z URL, aby stránka při přímém otevření kiosku/displeje
    // neblikala (nejdřív Login/Loader a až pak cílový krok).
    const getInitialRouteState = () => {
        if (typeof window === 'undefined') {
            return { step: 4, id: null, room: null, orgID: null, kiosk: null };
        }
        // Číst parametry z query (?room=...) NEBO z hashe (#?room=... nebo #/...?room=...)
        // Funguje jak na root URL (/) tak na /admin/ URL
        const search = window.location.search;
        const hashPart = window.location.hash ? window.location.hash.replace(/^#\/?/, '') : '';
        const hashQueryStart = hashPart.indexOf('?');
        const hashQuery = hashQueryStart >= 0 ? hashPart.substring(hashQueryStart) : '';
        const params = new URLSearchParams(search || hashQuery);
        let id = params.get("id");
        let room = params.get("room");
        let orgID = params.get("orgID");
        let kiosk = params.get("kiosk");

        // Nepoužívat sessionStorage – prázdná URL = čerstvý start (login/dashboard)

        // Uložit parametry pro pozdější použití (např. refresh)
        if (id || room || orgID) {
            try {
                sessionStorage.setItem("kioskDisplayParams", JSON.stringify({ id, room, orgID, kiosk }));
            } catch (_) {}
        }

        // Nejčastější přímé odkazy
        if (id === "100") return { step: 100, id, room, orgID, kiosk };
        if (id === "101") return { step: 101, id, room, orgID, kiosk };

        // id >= 200 = orgShortId (krátké URL pro nové orgy). Loader, dokud
        // isElev() neudělá /resolveOrgDevice lookup a nepřemapuje na 100/101.
        const idNum = Number(id);
        if (Number.isFinite(idNum) && idNum >= 200) return { step: 4, id, room, orgID, kiosk };

        // Obecně: když je v URL id, neskákej na login, ukaž loader a nech doběhnout isElev()
        // Funguje jak na root URL (/) tak na /admin/ URL
        if (id) return { step: 4, id, room, orgID, kiosk };

        // Bez query → normální start (login/auto-login)
        return { step: 0, id: null, room: null, orgID: null, kiosk: null };
    };
    const initialRoute = getInitialRouteState();

    const [step, setStep] = useState(initialRoute.step)
    const [slides, setSlides] = useState([])
    const [slidesAD, setSlidesAD] = useState([])
    const [slidesEF, setSlidesEF] = useState([])
    const [defaultABCD, setDefaultABCD] = useState([]);
    const [defaultEF, setDefaultEF] = useState([]);
    const [testSlides, setTestSlides] = useState([log, logoo])
    const [testSlides2, setTestSlides2] = useState([logoo])
    const [roomDetail, setRoomDetail] = useState("Undefined")
    // OrgID získané z backendu (getRoomDetail) — pro případ, kdy URL
    // neobsahuje orgID parametr (např. id=101&room=X bez orgID).
    const [roomOrgIdFromBackend, setRoomOrgIdFromBackend] = useState(null)
    const [roomTime, setRoomTime] = useState("Undefined")
    const [slidesObject, setslidesObject] = useState([]);
    const [meetingLogo, setmeetingLogo] = useState()
    const [meetingText, setmeetingText] = useState()
    const [kiosk6data, setkiosk6data] = useState()
    const [slidesADroom, setSlidesADroom] = useState([])
    const [slidesEFroom, setSlidesEFroom] = useState([])
    const [slidesO, setSlidesO] = useState([])
    const [slidesOroom, setSlidesOroom] = useState([])
    const [kioskSlidesAD, setKioskSlidesAD] = useState([])
    const [kioskSlidesEF, setKioskSlidesEF] = useState([])
    const [kioskSlidesO, setKioskSlidesO] = useState([])
    const [para, setPara] = useState(initialRoute.id)
    const [roomId, setRoomId] = useState(initialRoute.room)
    const [kiosk, setKiosk] = useState(initialRoute.kiosk)
    const [orgid , setOrgid] = useState(initialRoute.orgID)

    // Chrome tab title: aby neukazoval jen "Kiosk"/"displej", ale název konkrétního zařízení.
    useEffect(() => {
        if (typeof document === 'undefined') return;
        let cancelled = false;

        const run = async () => {
            const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
            const hasRoomParam = roomId != null && roomId !== '';
            const parsedDeviceId = hasRoomParam
                ? (typeof roomId === 'string' ? parseInt(roomId, 10) : roomId)
                : null;

            // 1) Preferovat deviceDescription (pokud se dá)
            if (Number.isFinite(parsedDeviceId)) {
                try {
                    const r = await axios.get(`${path}/getDeviceSettings/${parsedDeviceId}`);
                    const desc = r?.data?.deviceDescription;
                    if (desc && !cancelled) {
                        document.title = String(desc);
                        return;
                    }
                } catch (_) {
                    // ignore, fallback níže
                }
            }

            // 1.5) Holiday Inn (to je speciální případ): pro ?id=12/?id=13 často není v URL `room=<deviceId>`.
            // V tom případě `id` je jen "view id" a nesmí se používat jako deviceId (jinak titulky padají na špatné zařízení).
            // Holiday Inn "view id" titulek: u těchto obrazovek často není v URL `room=<deviceId>` ani `orgID`,
            // takže musíme mapovat podle `id` přímo (aby admin/totem ukazoval správný A-D / E-F).
            if (!cancelled && !hasRoomParam) {
                const viewId = String(para ?? '');
                const fallbackByViewId = {
                    '3': 'Totem',
                    '11': 'C',
                    '12': 'A-D',
                    '13': 'E-F',
                };
                if (fallbackByViewId[viewId]) {
                    document.title = fallbackByViewId[viewId];
                    return;
                }
            }

            // 2) Fallback: název organizace (hotel), pokud je v URL orgID
            if (orgid) {
                try {
                    const r = await axios.get(`${path}/getOrganization/${encodeURIComponent(orgid)}`);
                    const name = r?.data?.[0]?.name;
                    if (name && !cancelled) document.title = String(name);
                } catch (_) {
                    // ignore
                }
            }
        };

        run();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomId, para, orgid]);

    // Kiosk/displej (100/101): zachovat URL s parametry – pokud někdo přepsal, obnovit (Radisson = krátká URL)
    useEffect(() => {
        if ((step === 100 || step === 101) && roomId && orgid) {
            const params = new URLSearchParams(window.location.search);
            const hasParams = params.get('id') && (step === 101 ? params.get('room') : true);
            if (!hasParams) {
                const orgIdUpper = (orgid || '').toString().trim().toUpperCase();
                const isRadissonBlu = orgIdUpper === RADISSON_BLU_ORG_ID.toUpperCase();
                const q = new URLSearchParams();
                if (isRadissonBlu && step === 101) {
                    q.set('id', '5');
                    q.set('room', String(roomId));
                } else if (isRadissonBlu && step === 100) {
                    q.set('id', '7');
                } else {
                    q.set('id', String(step));
                    q.set('room', String(roomId));
                    q.set('orgID', String(orgid));
                }
                window.history.replaceState(null, '', `${window.location.pathname}?${q.toString()}`);
            }
        }
    }, [step, roomId, orgid]);

    //--78cb1180-46dd-4a14-a592-8ae867654f43 Menu
    //--ba746272-0fde-4700-8e15-f7362db631d2 SpecMenu
    const isElev = async (par, roomid, orgID, kiosk) => {
        //par != null ? get_slides_handler(par) : setStep(0)
        console.log(`[MainJS] isElev called: par=${par}, roomid=${roomid}, orgID=${orgID}, kiosk=${kiosk}`);
        // Krátké URL pro nové orgy: id = orgShortId (>= 200), room = device localId.
        // Backend lookup → zjistíme device_group + skutečné orgID, pak pokračujeme
        // existující dispatch logikou (id=100 kiosk, id=101 display).
        const parNum = Number(par);
        if (Number.isFinite(parNum) && parNum >= 200 && roomid != null && roomid !== '') {
            try {
                const resp = await axios.get(`${path}/resolveOrgDevice?orgShortId=${parNum}&room=${encodeURIComponent(roomid)}`);
                const dev = resp?.data;
                if (dev && dev.cOrganization_id) {
                    const resolvedOrgId = dev.cOrganization_id;
                    const dg = Number(dev.device_group);
                    // device_group=1 → display (id=101), 2 → kiosk (id=100)
                    const mappedId = dg === 1 ? 101 : 100;
                    // Pro display routing potřebujeme globální device.id (getRoomDetail/{id}),
                    // ne localId. Backend vrací dev.id (globální).
                    const resolvedRoomId = dev.id != null ? dev.id : roomid;
                    console.log('[MainJS] resolveOrgDevice', { shortId: parNum, roomLocalId: roomid, deviceGlobalId: resolvedRoomId, mappedId, orgID: resolvedOrgId });
                    setRoomId(resolvedRoomId);
                    setPara(mappedId);
                    setKiosk(kiosk);
                    setOrgid(resolvedOrgId);
                    get_slides_handler(mappedId, resolvedRoomId, resolvedOrgId);
                    return;
                }
            } catch (e) {
                console.warn('[MainJS] resolveOrgDevice failed:', e?.message || e);
            }
            // Fallback: nepodařilo se resolvnout — spadnout do původní cesty
        }
        setRoomId(roomid)
        setPara(par)
        setKiosk(kiosk)
        setOrgid(orgID)
        if (par != null) {
            get_slides_handler(par,roomid,orgID)
        }
        else {
            setStep(0)
        }
    }
    const getDefaultSlides = async () => {
        let tmpA = []
        let tmpB = []
        let response = await axios.get(`${path}/getDefaultScreen`);
        const norm = (p) => (p || '').replace(/\\/g, '/');
        for (let i = 0; i < (response.data?.length || 0); i++) {
            const item = response.data[i];
            if (item.id == 1) tmpA.push(assetsBaseUrl + norm(item.path));
            if (item.id == 2) tmpB.push(assetsBaseUrl + norm(item.path));
        }
        // Pokud je nastaven jen jeden obrázek (Top nebo Bottom), použít ho pro obě pozice – aby nahoře i dole něco bylo
        if (tmpA.length && !tmpB.length) tmpB = [...tmpA];
        if (tmpB.length && !tmpA.length) tmpA = [...tmpB];
        setDefaultABCD([...tmpA]);
        setDefaultEF([...tmpB]);
        if (tmpA.length || tmpB.length) console.log('[MainJS] Default slide URLs (A/B):', tmpA, tmpB);
    }

    const get_slides_handler = async (id,roomid,orgID) => {
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const day = dt.getDay() // 0 = neděle, 1 = pondělí, ..., 6 = sobota
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        const parseApiDate = (value) => {
            if (!value) return null;
            if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
            const raw = String(value).trim();
            if (!raw) return null;
            // Parse strictly as local time and ignore timezone suffix.
            // This avoids UTC/local shifts that can hide currently running meetings.
            const clean = raw
                .replace('T', ' ')
                .replace(/\.\d+$/, '')
                .replace(/[+-]\d{2}:?\d{2}$/, '')
                .replace(/Z$/, '');
            const [datePart, timePart] = clean.split(' ');
            if (!datePart || !timePart) return null;
            const [yStr, mStr, dStr] = datePart.split('-');
            const [hStr, minStr, secStr] = timePart.split(':');
            const y = Number(yStr);
            const m = Number(mStr);
            const d = Number(dStr);
            const h = Number(hStr);
            const min = Number(minStr);
            const sec = Number(secStr || 0);
            if (![y, m, d, h, min, sec].every((n) => Number.isFinite(n))) return null;
            const parsed = new Date(y, m - 1, d, h, min, sec);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        };
        const filterActiveMeetingsNow = (rows) => {
            if (!Array.isArray(rows)) return [];
            const now = new Date();
            return rows.filter((row) => {
                const from = parseApiDate(row?.dateFrom || row?.DateFrom || row?.date_from);
                const to = parseApiDate(row?.dateTo || row?.DateTo || row?.date_to);
                // Když backend nepošle časy, necháme záznam projít (fallback na backend filtr).
                if (!from || !to) return true;
                return from <= now && now < to;
            });
        };
        // Cesty z API/DB mohou mít zpětná lomítka (Windows) – normalizovat pro URL
        const assetUrl = (p) => assetsBaseUrl + (p || '').replace(/\\/g, '/');
        // Pro id 3 (totem) a 11/12/13 (Holiday Inn totem) – bez orgID v URL použít Holiday Inn jako výchozí
        const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
        if ((id == 3 || id == 11 || id == 12 || id == 13) && !orgID) {
            const params = new URLSearchParams(window.location.search);
            orgID = params.get('orgID') || orgID;
            if (!orgID) orgID = HOLIDAY_INN_ORG_ID;
            // Keep state in sync so child components (e.g. RoomDouble) receive org prop.
            setOrgid(orgID);
        }
        let response
        try {
            if (id == 1) {
                console.log(`[MainJS] Fetching getDayCard for day=${day}, path=${path}`);
                response = await axios.get(`${path}/getDayCard/${day}`);
                console.log(`[MainJS] getDayCard response:`, response.data);
            }
            if (id == 2) {
                response = await axios.get(`${path}/getCardsV2?orgID=AC9D7FD5-E333-4B1E-9043-4697568313B7&onlyVisible=1`);
            }
            if (id == 3 || (id == 11 && (roomid == null || roomid === '' || roomid === undefined))) {
                await getDefaultSlides()

                // Načíst meeting room záznamy – hned nastavit, aby se směr (A-D / E-F / O) zobrazil při běžícím meetingu (platí i pro /admin/?id=3&orgID=... a ?id=11)
                try {
                    response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(orgID)}&day=${encodeURIComponent(actTime)}&_t=${Date.now()}`);
                    if (Array.isArray(response?.data)) {
                        setObjetotem(filterActiveMeetingsNow(response.data), id);
                    } else {
                        setObjetotem([], id);
                    }
                } catch (err) {
                    console.warn('[MainJS] getRecordsNowV2 for id=3/11 failed:', err?.message || err);
                    setObjetotem([], id);
                }

                // Načíst obrázky z kiosk slideshow pro popupy (včetně "all cards" / no group → id=3 / id=11)
                try {
                    const kioskCardsResponse = await axios.get(`${path}/getCardsV2?orgID=${orgID}&onlyVisible=1`);
                    const kioskCards = Array.isArray(kioskCardsResponse.data) ? kioskCardsResponse.data : [];
                    
                    let kioskAD = []
                    let kioskEF = []
                    let kioskO = []
                    const noGroupUrls = []
                    
                    for (let i = 0; i < kioskCards.length; i++) {
                        const card = kioskCards[i];
                        const roomGroupId = card.cRoomGroup_id;
                        const url = assetUrl(card.path);
                        if (roomGroupId == 1) {
                            kioskAD.push(url)
                        } else if (roomGroupId == 3) {
                            kioskEF.push(url)
                        } else if (roomGroupId == 10) {
                            kioskO.push(url)
                        } else if (roomGroupId == null || roomGroupId === undefined || roomGroupId === 0 || roomGroupId === '') {
                            noGroupUrls.push(url)
                        }
                    }
                    // Karty bez skupiny ("all cards") jdou na url ?id=3 – přidat do všech tří sekcí
                    if (noGroupUrls.length > 0) {
                        kioskAD = [...kioskAD, ...noGroupUrls]
                        kioskEF = [...kioskEF, ...noGroupUrls]
                        kioskO = [...kioskO, ...noGroupUrls]
                    }
                    
                    setKioskSlidesAD([...kioskAD])
                    setKioskSlidesEF([...kioskEF])
                    setKioskSlidesO([...kioskO])
                    console.log('[MainJS] Kiosk slides loaded for id=3/11:', { kioskAD, kioskEF, kioskO, noGroup: noGroupUrls.length })
                } catch (error) {
                    console.error('[MainJS] Error loading kiosk slides:', error)
                }
                
                setStep(3)  // SlideshowTotem (?id=3 nebo ?id=11 bez room)
            }
            if (id == 4) {

                setStep(4)

            }
            if (id == 5 ) {
                response = await axios.get(`${path}/getRoomDetail/${roomid}`);
                setRoomDetail(response.data[0].description)
                response = await axios.get(`${path}/getMeeting/${roomid}/${encodeURIComponent(actTime)}`);
                setmeetingLogo(assetUrl(response.data[0].path))
                setmeetingText(response.data[0].description)
                id == 5 && setStep(5)

            }
            if (id == 72 ) {
                response = await axios.get(`${path}/getRoomDetail/${roomid}`);
                setRoomDetail(response.data[0].description)
                response = await axios.get(`${path}/getMeeting/${roomid}/${encodeURIComponent(actTime)}`);
                setmeetingLogo(assetUrl(response.data[0].path))
                setmeetingText(response.data[0].description)
                id == 72 && setStep(72)

            }

            if (id == 101 ) {
                console.log(`[MainJS] get_slides_handler for id=101: roomid=${roomid}, actTime=${actTime}`);
                response = await axios.get(`${path}/getRoomDetail/${roomid}`);
                setRoomDetail(response.data[0].description)
                // Uložit orgID místnosti (potřebné když URL nepředává orgID
                // — Room_FAIRMONT pak ví, který hotel rendrovat).
                if (response.data[0]?.cOrganization_id) {
                    setRoomOrgIdFromBackend(response.data[0].cOrganization_id);
                }
                // Use query parameter endpoint directly for production (dev.csgcontrols.cz) due to IIS routing issues
                const useQueryEndpoint = path.includes('dev.csgcontrols.cz') || path.includes('csgcontrols.cz');
                const meetingUrl = useQueryEndpoint 
                    ? `${path}/getMeetingQuery?id=${roomid}&day=${encodeURIComponent(actTime)}`
                    : `${path}/getMeeting/${roomid}/${encodeURIComponent(actTime)}`;
                console.log(`[MainJS] Fetching meeting: ${meetingUrl}, useQueryEndpoint=${useQueryEndpoint}`);
                response = await axios.get(meetingUrl);
                console.log(`[MainJS] Meeting response:`, response.data);
                setmeetingLogo(assetUrl(response.data[0].path))
                setmeetingText(response.data[0].description)
                id == 101 && setStep(101)

            }
            if (id ==  100) {
                // Diplomat Prague keeps legacy kiosk URL ?id=100; route it to Diplomat kiosk view.
                if (String(orgID || '').toUpperCase() === DIPLOMAT_PRAGUE_ORG_ID.toUpperCase()) {
                    setStep(16);
                } else {
                    setStep(100);
                }
            }

            if (id == 6) {
                // Vienna House kiosk: kiosk=1 (dolní) / kiosk=2 (horní) – vždy načíst z URL před zobrazením
                const hashPart = window.location.hash ? window.location.hash.replace(/^#\/?/, '') : '';
                const hashQ = hashPart.indexOf('?') >= 0 ? hashPart.substring(hashPart.indexOf('?')) : '';
                const q = new URLSearchParams(hashQ || window.location.search);
                const kioskParam = q.get('kiosk');
                setKiosk((kioskParam === '1' || kioskParam === '2') ? kioskParam : '1');
                setStep(6);
            }
            if (id ==  80) {
                //response = await axios.get(`${path}/getCards`);
                //response = await axios.get(`${path}/getCards`);
                setStep(80)
            }
            if (id ==  7) {
                response = await axios.get(`${path}/getDayListV2?orgID=AC9D7FD5-E333-4B1E-9043-4697568313B7&&day=${actTime}`);
                if(response.data.length > 0)
                {
                    console.log(response.data)
                    setkiosk6data(response.data)
                    setStep(7)
                }
                else {
                    get_slides_handler(2,roomid)
                }

            }
            if (id ==  70) {
                response = await axios.get(`${path}/getDayListV2?orgID=7A67452A-F5D4-430D-B283-8A93B28B425C&&day=${actTime}`);
                if(response.data.length > 0)
                {
                    console.log(response.data)
                    setkiosk6data(response.data)
                    setStep(70)
                }
                else {
                    get_slides_handler(71,roomid)
                }

            }
            if (id == 71) {

                response = await axios.get(`${path}/getCardsV2?orgID=7A67452A-F5D4-430D-B283-8A93B28B425C&onlyVisible=1`);
                setStep(71)
            }
            if (id ==  8) {
                setStep(7)
            }
            if (id ==  9) {
                response = await axios.get(`${path}/getCardsV2Holiday`);
            }
            // Holiday Inn orgID: E15F8010-B7EB-4526-A985-F00D517EBF4C
            const isHolidayInn = orgID === 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
            
            if (id ==  11) {
                // id=11&room=25 → jedna místnost: RoomHI (fotka vlevo, meeting vpravo)
                // id=11 bez room → Holiday Inn totem (SlideshowTotem)
                const hasRoom = roomid != null && roomid !== '' && roomid !== undefined;
                if (isHolidayInn && hasRoom) {
                    getDefaultSlides();
                    let meetingData = [];
                    try {
                        const roomRes = await axios.get(`${path}/getRoomDetail/${roomid}`);
                        if (roomRes.data?.[0]?.description) setRoomDetail(roomRes.data[0].description);
                        response = await axios.get(`${path}/getMeeting1Query?id=${roomid}&day=${encodeURIComponent(actTime)}&_t=${Date.now()}`);
                        meetingData = Array.isArray(response.data) ? response.data : [];
                    } catch (err) {
                        console.warn('[MainJS] getMeeting1Query/getRoomDetail for room', roomid, err?.message || err);
                    }
                    setslidesObject({
                        id: roomid,
                        idTS: id,
                        object: meetingData
                    });
                    setStep(11);  // RoomHI – fotka vlevo, info o meetingu vpravo
                } else if (isHolidayInn && !hasRoom) {
                    // id=11 bez room je řešeno výše společně s id=3 (SlideshowTotem),
                    // aby nedocházelo ke dvojímu načítání a "zaseklým" meetingům.
                } else {
                    // Ostatní organizace: RoomHI
                    getDefaultSlides()
                    response = await axios.get(`${path}/getRoomDetail/${roomid}`);
                    const description = response.data[0].description
                    setRoomDetail(description)
                    response = await axios.get(`${path}/getMeeting1Query?id=${roomid}&day=${encodeURIComponent(actTime)}&_t=${Date.now()}`);
                    setslidesObject({
                        id: roomid,
                        idTS: id,
                        object: response.data
                    })
                    setStep(11)  // RoomHI
                }
            }
            if (id == 12  || id == 13) {
                // Pro Holiday Inn id=13 použít RoomDouble (E–F vedle sebe), pro id=12 SlideshowTotem
                if (isHolidayInn && id == 13) {
                    getDefaultSlides();
                    response = await axios.get(`${path}/getRecordsNowV2?orgID=${orgID}&day=${encodeURIComponent(actTime)}&_t=${Date.now()}`);
                    const raw = filterActiveMeetingsNow(Array.isArray(response.data) ? response.data : []);
                    // Nepoužívej jen cRoomGroup_id === 3 – nechej RoomDouble, aby E/F detekoval z názvu místností
                    const object = raw.map((item) => ({
                        description: item.room,
                        path: (item.path || '').replace(/\\/g, '/')
                    }));
                    setslidesObject({
                        id: roomid,
                        idTS: id,
                        object
                    });
                    setStep(67);
                } else if (isHolidayInn) {
                    // Pro Holiday Inn id=12 použít SlideshowTotem – stejná data jako id=3 (směr + meeting A–D)
                    await getDefaultSlides();
                    try {
                        response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(orgID)}&day=${encodeURIComponent(actTime)}&_t=${Date.now()}`);
                        if (Array.isArray(response?.data)) setObjetotem(filterActiveMeetingsNow(response.data), id);
                    } catch (err) {
                        console.warn('[MainJS] getRecordsNowV2 for id=12 failed:', err?.message || err);
                    }
                    // Načíst obrázky z kiosk slideshow pro popupy (včetně "all cards" / no group → id=3)
                    try {
                        const kioskCardsResponse = await axios.get(`${path}/getCardsV2?orgID=${orgID}&onlyVisible=1`);
                        const kioskCards = Array.isArray(kioskCardsResponse.data) ? kioskCardsResponse.data : [];
                        
                        let kioskAD = []
                        let kioskEF = []
                        let kioskO = []
                        const noGroupUrls = []
                        
                        for (let i = 0; i < kioskCards.length; i++) {
                            const card = kioskCards[i];
                            const roomGroupId = card.cRoomGroup_id;
                            const url = assetUrl(card.path);
                            if (roomGroupId == 1) {
                                kioskAD.push(url)
                            } else if (roomGroupId == 3) {
                                kioskEF.push(url)
                            } else if (roomGroupId == 10) {
                                kioskO.push(url)
                            } else if (roomGroupId == null || roomGroupId === undefined || roomGroupId === 0 || roomGroupId === '') {
                                noGroupUrls.push(url)
                            }
                        }
                        if (noGroupUrls.length > 0) {
                            kioskAD = [...kioskAD, ...noGroupUrls]
                            kioskEF = [...kioskEF, ...noGroupUrls]
                            kioskO = [...kioskO, ...noGroupUrls]
                        }
                        
                        setKioskSlidesAD([...kioskAD])
                        setKioskSlidesEF([...kioskEF])
                        setKioskSlidesO([...kioskO])
                        console.log('[MainJS] Kiosk slides loaded for id=12/13:', { kioskAD, kioskEF, kioskO, noGroup: noGroupUrls.length })
                    } catch (error) {
                        console.error('[MainJS] Error loading kiosk slides:', error)
                    }
                    
                    setStep(3)  // SlideshowTotem
                } else {
                    // Pro ostatní organizace použít RoomVertical/RoomDouble
                    getDefaultSlides()
                    let pth=[]
                    if (id == 12) response = await axios.get(`${path}/getMeeting2/${encodeURIComponent(actTime)}`);
                    if (id == 13) response = await axios.get(`${path}/getMeeting3/${encodeURIComponent(actTime)}`);
                    if(response.data.length > 0){
                        console.log("amp")
                        for (let i = 0; i < response.data.length; i++) {
                            let p = {
                                room:response.data[i].description,
                                logo: assetUrl(response.data[i].path)
                            }
                            pth.push(p)
                        }
                    }
                    else {
                        console.log("ne")
                        pth = [{
                            room:"",
                            logo:null
                        }]
                    }
                    setslidesObject({
                        id:roomid,
                        idTS:id,
                        object:response.data
                    })
                    id ==12 && setStep(66)  // RoomVertical
                    id ==13 && setStep(67)  // RoomDouble
                }
            }
            if (id == 15 ) {
                response = await axios.get(`${path}/getRoomDetail/${roomid}`);
                setRoomDetail(response.data[0].description)
                response = await axios.get(`${path}/getMeeting/${roomid}/${actTime}`);
                setRoomTime(`${response.data[0].dateFrom.substring(11,16)} - ${response.data[0].dateTo.substring(11,16)}`)
                setmeetingLogo(assetUrl(response.data[0].path))
                setmeetingText(response.data[0].description)
                id == 15 && setStep(15)

            }
            if (id == 16 ) {
                setStep(16)

            }
            if (id == "newsFetch") {

                setStep("newsFetch")

            }
            if (id == 1 || id == 2 || id == 9 || id == 71) {
                const loadedData = JSON.parse(sessionStorage.getItem('key'));
                if (response.data?.length) {
                    const normPaths = response.data.map((item) => item?.path ? { ...item, path: item.path.replace(/\\/g, '/') } : item);
                    sessionStorage.setItem('key', JSON.stringify(normPaths));
                    setObje(normPaths, id);
                    console.log('stored:', JSON.parse(sessionStorage.getItem('key')));
                } else {
                    setObje(loadedData != null ? loadedData : [], id);
                }
            }

        } catch (error) {
            if (id == 1 || id == 2 || id == 9 || id == 71) {
                console.error('Fetching cards Error', error.message);
                const loadedData = JSON.parse(sessionStorage.getItem('key'))
                setObje(loadedData, id)
            }
            if (id == 3) {
                setStep(3)
            }
            if (id == 5) {
                setStep(5)
            }
            if (id == 72) {
                setStep(72)
            }
            if (id == 101) {
                setStep(101)
            }
            id == 15 && setStep(15)
            if (id == 5) {
                console.log("BuBu")
            }
        }

    }
    const get_slides_Records_handler = async (id) => {
        const dt = new Date
        let response
        try {
            if (id == 1) {
                response = await axios.get(`${path}/getDayCard/${id}`);
            }

            const loadedData = JSON.parse(sessionStorage.getItem('key'))
            response.data.length != 0 ? setObje(response.data, id) : loadedData != null ? setObje(loadedData, id) : setObje([], id)
            response.data.length != 0 && sessionStorage.setItem('key', JSON.stringify(response.data));
            console.log("stored:", JSON.parse(sessionStorage.getItem('key')))
        } catch (error) {
            console.error('Fetching cards Error', error.message);
            const loadedData = JSON.parse(sessionStorage.getItem('key'))
            setObje(loadedData, id)
        }

    }
    const setObje = (x, id) => {
        if (!x || !Array.isArray(x)) {
            console.error('[MainJS] setObje: Invalid data', x);
            return;
        }
        let fld = []
        for (let i = 0; i < x.length; i++) {
            if (!x[i] || !x[i].path) {
                console.warn('[MainJS] setObje: Skipping item without path', x[i]);
                continue;
            }
            const imgUrl = assetsBaseUrl + (x[i].path || '').replace(/\\/g, '/');
            let temp = {
                imgURL: imgUrl,
            }
            fld.push(imgUrl)
        }
        console.log(`[MainJS] setObje: Setting ${fld.length} slides for id=${id}`, fld);
        setSlides([...fld])
        setUser({
            id: id,
            type: 2,
            username: "monitor - Menu",
            slides: []
        })
        id == 1 && setStep(10)
        id == 2 && setStep(2)
        id == 9 && setStep(10)
    }
    const setObjetotem = (x, displayId) => {
        if (!Array.isArray(x)) return;
        let fldAD = []
        let fldEF = []
        let fldO = []
        let fldADroom = []
        let fldEFroom = []
        let fldOroom = []
        const getRoomName = (item) => {
            const rd = String(item?.roomDescription || '').trim();
            const room = String(item?.room || '').trim();
            const rdNorm = rd.replace(/\s+/g, '').toUpperCase(); // "A - D" -> "A-D"

            const extractLetter = (allowed) => {
                if (!room) return null;
                const r = room.toUpperCase();
                // Meeting Room C / Room C
                const m1 = r.match(new RegExp(`MEETING\\s*ROOM\\s*([${allowed}])\\b`));
                if (m1?.[1]) return m1[1];
                const m2 = r.match(new RegExp(`\\bROOM\\s*([${allowed}])\\b`));
                if (m2?.[1]) return m2[1];
                // fallback: single-letter token
                const m3 = r.match(new RegExp(`\\b([${allowed}])\\b`));
                if (m3?.[1]) return m3[1];
                return null;
            };

            // Pokud je roomDescription jen obecná skupina (A-D / E-F), z room stringu vyber konkrétní písmeno.
            if (rdNorm === 'A-D') {
                return extractLetter('ABCD') || rd;
            }
            if (rdNorm === 'E-F') {
                return extractLetter('EF') || rd;
            }

            if (rd) return rd;
            if (room && room.length > 13) return room.substring(13);
            return room || '';
        };
        const isADGroup = (row) => {
            if (row.cRoomGroup_id == 1) return true;
            const rd = (row.roomDescription || '').toUpperCase();
            const room = (row.room || '').toUpperCase();
            if (rd === 'A-D' || rd === 'A - D') return true;
            if (/MEETING ROOM [ABCD]\b/.test(room) || /\b(ROOM )?[ABCD]\b/.test(room)) return true;
            return false;
        };
        const isEFGroup = (row) => {
            if (row.cRoomGroup_id == 3) return true;
            const rd = (row.roomDescription || '').toUpperCase();
            const room = (row.room || '').toUpperCase();
            if (rd === 'E-F' || rd === 'E - F') return true;
            if (/MEETING ROOM [EF]\b/.test(room) || /\b(ROOM )?[EF]\b/.test(room)) return true;
            // Meeting room Pop Up patří fyzicky do E-F bucketu (sdílí prostor /
            // přiřazení v cDevice.roomGroup = "E-F"), i když nemá vlastní
            // cRoomGroup_id záznam v cCalendarRecords.
            if (/POP[\s-]?UP/.test(room)) return true;
            return false;
        };
        const isOGroup = (row) => row.cRoomGroup_id == 10;
        for (let i = 0; i < x.length; i++) {
            const row = x[i];
            if (isADGroup(row)) {
                fldAD.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                fldADroom.push(getRoomName(row));
            }
            if (isEFGroup(row)) {
                fldEF.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                fldEFroom.push(getRoomName(row));
            }
            if (isOGroup(row)) {
                fldO.push(assetsBaseUrl + (row.path || '').replace(/\\/g, '/'));
                fldOroom.push(getRoomName(row));
            }
        }
        setSlidesAD([...fldAD]);
        setSlidesEF([...fldEF]);
        setSlidesO([...fldO]);
        setSlidesADroom([...fldADroom]);
        setSlidesEFroom([...fldEFroom]);
        setSlidesOroom([...fldOroom]);
        setUser({ id: displayId, type: 2, username: "monitor - Menu", slides: [] });
        setStep(3);
    }

    const login_handler = (type, id) => {
        type === 1 && setStep(1)
        type === 99 && setStep(99)
        if (type === 2) {
            get_slides_handler(id)
            //setStep(2)
        }
    }
const step_jump =(id) =>{
        isElev(id)
    }
    const changeStep_handler = (step) => {
        setStep(step)
    }
    const handle_logout = () => {
        // Odstranění přihlašovacích údajů z localStorage při odhlášení
        localStorage.removeItem('userData');
        setUser({})
        setStep(0)
    }
    const fill_data = (user, userType, id, org,logopath,orgName,pravo_slideshow,pravo_weekSlideshow,pravo_calendar,pravo_vienna,pravo_diplomat,allowKioskSettings = false) => {
        // Pokud jsou v URL parametry pro kiosk/displej, NEPŘEPISOVAT step - nechat URL parametry mít prioritu
        const currentParams = new URLSearchParams(window.location.search);
        const idFromUrl = currentParams.get("id");
        const roomFromUrl = currentParams.get("room");
        const orgIDFromUrl = currentParams.get("orgID");
        const kioskFromUrl = currentParams.get("kiosk");
        const hasKioskDisplayParams = idFromUrl !== null && idFromUrl !== undefined;
        
        setUser({
            id: id,
            type: userType,
            username: user,
            cOrganization_id: org,
            logopath: logopath,
            organizationName: orgName,
            pravo_slideshow: pravo_slideshow,
            pravo_weekSlideshow: pravo_weekSlideshow,
            pravo_calendar: pravo_calendar,
            pravo_vienna: pravo_vienna,
            pravo_diplomat: pravo_diplomat,
            allowKioskSettings: allowKioskSettings === true || allowKioskSettings === 1,
            slides: []
        })
        
        // Pokud jsou v URL parametry pro kiosk/displej, NEPŘEPISOVAT step - URL parametry mají prioritu
        if (hasKioskDisplayParams) {
            let idElev = idFromUrl;
            let roomID = roomFromUrl || roomId;
            let orgID = orgIDFromUrl || orgid;
            const kioskVal = kioskFromUrl || kiosk;
            // Radisson Blu: v adresním řádku nahradit dlouhé URL krátkým; uvnitř dál 101/100
            const orgIdUpper = (orgID || '').toString().trim().toUpperCase();
            if (orgIdUpper === RADISSON_BLU_ORG_ID.toUpperCase()) {
                if (idElev === '101' && roomID) {
                    window.history.replaceState(null, '', `${window.location.pathname}?id=5&room=${roomID}`);
                } else if (idElev === '100') {
                    window.history.replaceState(null, '', `${window.location.pathname}?id=7`);
                    idElev = '7';
                    roomID = null;
                    orgID = null;
                }
            }
            setPara(idElev);
            setRoomId(roomID);
            setOrgid(orgID);
            if (kioskFromUrl) setKiosk(kioskFromUrl);
            isElev(idElev, roomID, orgID, kioskVal);
            return;
        }
        
        // Krátce zobrazit loading před přechodem na dashboard (pouze pokud nejsou URL parametry)
        setStep(4)
        setTimeout(() => {
            login_handler(userType, id)
        }, 400)
    }
    useEffect(() => {
        day = new Date().getDay()
        // Použít hodnoty ze state (para, roomId, orgid, kiosk) – URL mohla být už přepsána replaceState
        // NEBO znovu načíst z URL, pokud byly změněny (např. při navigaci na /admin/?id=1)
        const currentParams = new URLSearchParams(window.location.search);
        const idFromUrl = currentParams.get("id");
        const roomFromUrl = currentParams.get("room");
        const orgIDFromUrl = currentParams.get("orgID");
        const kioskFromUrl = currentParams.get("kiosk");
        
        // Prioritizovat parametry z URL před state (pro případ, že URL byla změněna)
        let idElev = idFromUrl || para;
        let roomID = roomFromUrl || roomId;
        let orgID = orgIDFromUrl || orgid;
        const kioskVal = kioskFromUrl || kiosk;

        // Radisson Blu: dlouhé URL nahradit krátkým v adresním řádku; uvnitř dál používat 101/100 pro správný view
        const orgIdUpper = (orgID || '').toString().trim().toUpperCase();
        const isRadissonBlu = orgIdUpper === RADISSON_BLU_ORG_ID.toUpperCase();
        if (isRadissonBlu && idElev === '101' && roomID) {
            window.history.replaceState(null, '', `${window.location.pathname}?id=5&room=${roomID}`);
        } else if (isRadissonBlu && idElev === '100') {
            window.history.replaceState(null, '', `${window.location.pathname}?id=7`);
            idElev = '7';
            roomID = null;
            orgID = null;
        }
        // Krátká URL id=5&room=X bez orgID = Radisson displej (step 101)
        if (!orgID && idElev === '5' && roomID) {
            orgID = RADISSON_BLU_ORG_ID;
            idElev = '101';
        }
        // Krátká URL id=7 bez orgID = Radisson kiosk (step 7)
        if (!orgID && idElev === '7') {
            orgID = RADISSON_BLU_ORG_ID;
        }
        
        console.log(`[MainJS] URL params: id=${idElev}, room=${roomID}, orgID=${orgID}, kiosk=${kioskVal}`);
        console.log(`[MainJS] Full URL: ${window.location.href}`);
        console.log(`[MainJS] Pathname: ${window.location.pathname}`);
        
        // Pokud jsou v URL parametry pro kiosk/displej (id, room, orgID), VŽDY zobrazit kiosk/displej
        // i když je uživatel přihlášený nebo je na /admin/ stránce
        if (idElev) {
            // Máme parametry pro kiosk/displej - zobrazit je (state s normalizovanými hodnotami pro Radisson)
            setPara(idElev);
            setRoomId(roomID);
            setOrgid(orgID);
            if (kioskFromUrl) setKiosk(kioskFromUrl);
            
            isElev(idElev, roomID, orgID, kioskVal);
            return;
        }
        
        // Kontrola, jestli je uživatel přihlášený (z localStorage) - pouze pokud nejsou URL parametry
        const savedUserData = localStorage.getItem('userData');
        if (savedUserData) {
            try {
                const userData = JSON.parse(savedUserData);
                // Automatické přihlášení, pokud jsou uložené údaje a nejsou URL parametry pro kiosk/displej
                fill_data(
                    userData.username,
                    userData.userType,
                    userData.id,
                    userData.cOrganization_id,
                    userData.logoPath,
                    userData.Organizace,
                    userData.modul_slideshow,
                    userData.modul_week_slideshow,
                    userData.modul_calendar_navigation,
                    userData.modul_vienna_slide,
                    userData.modul_diplomat,
                    userData.allowKioskSettings === true || userData.allowKioskSettings === 1
                );
                // fill_data už zkontrolovala URL parametry a pokud jsou, zavolala isElev a vrátila se
                // Pokud nejsou URL parametry, fill_data nastaví step=4 a zavolá login_handler
                return; // Nepokračovat v isElev, pokud je uživatel přihlášený
            } catch (error) {
                console.error('Error parsing saved user data:', error);
                localStorage.removeItem('userData'); // Odstranit neplatná data
            }
        }
        
        // Pokud není přihlášený uživatel a nejsou URL parametry, pokračovat normálně
        isElev(idElev, roomID, orgID, kioskVal)
    }, [])

    // Heartbeat pro displej (id=101), aby admin Servis zobrazoval stav i u displejů
    useEffect(() => {
        if (step !== 101 || !roomId) return;
        const deviceId = typeof roomId === 'string' ? parseInt(roomId, 10) : roomId;
        if (!Number.isFinite(deviceId)) return;
        const send = () => {
            if (typeof window === 'undefined') return;
            const p = new URLSearchParams(window.location.search);
            const payload = {
                url_id: p.get('id'),
                url_room: p.get('room'),
                url_orgID: p.get('orgID'),
                url_kiosk: p.get('kiosk'),
            };
            axios.post(`${path}/heartbeat/${deviceId}`, payload).catch(() => {});
        };
        send();
        const interval = setInterval(send, 60000);
        return () => clearInterval(interval);
    }, [step, roomId])

    // Automatické obnovení obsahu kiosku/displeje: při změně (interval + při návratu na záložku)
    const isKioskDisplayView = step !== 0 && step !== 1 && step !== 4 && step !== 99 && para != null && para !== '';
    const REFRESH_INTERVAL_MS = 60000; // 1 minuta

    useEffect(() => {
        if (!isKioskDisplayView) return;
        const refresh = () => {
            get_slides_handler(para, roomId, orgid);
        };
        const interval = setInterval(refresh, REFRESH_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [isKioskDisplayView, para, roomId, orgid])

    // Při návratu na záložku (tab je znovu viditelný) vždy obnovit data
    useEffect(() => {
        if (!isKioskDisplayView) return;
        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                get_slides_handler(para, roomId, orgid);
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => document.removeEventListener('visibilitychange', onVisibilityChange);
    }, [isKioskDisplayView, para, roomId, orgid])

    // Totem (id=3, id=11, id=12): když je zobrazen ale meeting data chybí, znovu načíst po 800 ms
    useEffect(() => {
        if (step !== 3) return;
        const paraNum =
            para === 3 ||
            para === '3' ||
            para === 11 ||
            para === '11' ||
            para === 12 ||
            para === '12';
        if (!paraNum) return;
        if (slidesAD.length > 0 || slidesEF.length > 0) return;
        if (!orgid) return;
        const t = setTimeout(() => {
            get_slides_handler(para, roomId, orgid);
        }, 800);
        return () => clearTimeout(t);
    }, [step, para, orgid, slidesAD.length, slidesEF.length]);

    // Holiday Inn (id=3/11/12/13): rychlejší refresh meetingů kvůli změnám času v administraci
    // Platí i pro room view (step 11/67), ne jen pro totem (step 3).
    useEffect(() => {
        const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
        if ((orgid || '').toUpperCase() !== HOLIDAY_INN_ORG_ID) return;
        const isHolidayInnMeetingDisplay =
            para === 3 ||
            para === "3" ||
            para === 11 ||
            para === "11" ||
            para === 12 ||
            para === "12" ||
            para === 13 ||
            para === "13";
        if (!isHolidayInnMeetingDisplay || !orgid) return;
        const interval = setInterval(() => {
            get_slides_handler(para, roomId, orgid);
        }, 15000);
        return () => clearInterval(interval);
    }, [para, roomId, orgid]);

    return <div>
        {
            step === 0 && <Login changeStep={changeStep_handler} dataFill={fill_data}/>
        }
        {
            step === 1 &&
            <Dashboard changeStep={changeStep_handler} previewSlidesChange={get_slides_handler} cred={user}
                       logOut={handle_logout}/>
        }
        {
            step === 99 &&
            <Dashboard_admin changeStep={changeStep_handler} previewSlidesChange={get_slides_handler} cred={user}
                       logOut={handle_logout}/>
        }
        {
            step === 2 &&
            <Slideshow changeStep={changeStep_handler} slideshow={slides} cred={user} slideshowAD={slidesAD}
                       slideshowEF={slidesEF} jump={step_jump}/>
        }
        {
            step === 3 &&
            <SlideshowTotem changeStep={changeStep_handler} slideshow={slides} cred={user} slideshowAD={slidesAD}
                            slideshowEF={slidesEF} slideshowO={slidesO} defA={defaultABCD} defB={defaultEF} adroom={slidesADroom} efroom={slidesEFroom} oroom={slidesOroom}
                            kioskSlidesAD={kioskSlidesAD} kioskSlidesEF={kioskSlidesEF} kioskSlidesO={kioskSlidesO} displayId={para} orgId={orgid} />
        }
        {
            step === 4 &&
            <Loader/>
        }
        {
            step === 5 &&
            <Room roomName={roomDetail} logoOrg={meetingLogo} text={meetingText} roomId={roomId}/>
        }

        {
            (step === 6 ) && <Kiosk_viennaPlzen_redesign id={kiosk}/>
            //<Kiosk id={kiosk}/>
            //<Kiosk_viennaPlzen_redesign id={kiosk}/>
        }
        {
            step === 7 &&
            <RadKiosk data={kiosk6data} jump={step_jump} />
        }
        {
            step === 11 &&
            <RoomHI object={slidesObject} default={[defaultABCD[0],defaultEF[0]]} roomName={roomDetail}/>
        }
        {
            step === 10 &&
            // eslint-disable-next-line react/jsx-pascal-case
            <Slide_bistro changeStep={changeStep_handler} slideshow={slides} cred={user} slideshowAD={slidesAD}
                       slideshowEF={slidesEF} jump={step_jump}/>
        }
        {
            step === 66 &&
            <RoomVertical object={slidesObject} default={[defaultABCD[0],defaultEF[0]]}/>
        }
        {
            step === 67 &&
            <RoomDouble object={slidesObject} default={[defaultABCD[0],defaultEF[0]]} org={orgid}/>
        }
        {
            step === 15 &&
            <RoomDiplomat roomTime={roomTime} roomName={roomDetail} logoOrg={meetingLogo} text={meetingText} roomId={roomId}/>
        }
        {
            step === 16 &&
            <KioskDiplomat id={kiosk} roomId={roomId} org={orgid}/>
        }
        {
            step === "newsFetch" &&
            <NewsFetchPost/>
        }
        {
            step === 70 &&
            <RadKiosk_FAIRMONT data={kiosk6data} jump={step_jump} />
        }
        {
            step === 71 &&
            <Slideshow_FAIRMONT changeStep={changeStep_handler} slideshow={slides} cred={user} slideshowAD={slidesAD}
                       slideshowEF={slidesEF} jump={step_jump}/>
        }
        {
            step === 72 &&
            <RoomFairmont roomName={roomDetail} logoOrg={meetingLogo} text={meetingText} roomId={roomId}/>
        }
        {
            (step === 80 ) && <Kiosk_Harrachov id={kiosk}/>
        }

        {
            (step === 100) && (() => {
                const oid = (orgid || '').toString().trim().toUpperCase();
                if (oid === FAIRMONT_GOLDEN_PRAGUE_ORG_ID.toUpperCase()) return <FairmontKiosk />;
                if (oid === SKP_HOPO_ORG_ID.toUpperCase()) return <SkpKiosk />;
                return <KIOSK_def id={kiosk} org={orgid} room={roomId}/>;
            })()
        }
        {
            step === 101 &&
            <RoomFairmont roomName={roomDetail} logoOrg={meetingLogo} org={orgid || roomOrgIdFromBackend} text={meetingText} roomId={roomId}/>
        }

    </div>
}

export default MainJS